'use client';

import { useTranslations } from 'next-intl';

export const useT = () => {
  const t = useTranslations();

  const wrapped = ((key: string) => {
    const raw = t.raw(key);
    if (typeof raw === 'string' && raw.includes('<')) return raw;
    return t(key);
  }) as typeof t & { raw: typeof t.raw };

  return Object.assign(wrapped, {
    raw: t.raw,
  });
};
